import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useConfirm } from 'material-ui-confirm';

import { useSelector, useDispatch } from '../../store/utils';
import { variablesChange } from '../../store/actions';
import { confirmYesNo } from '../../utils/use-confirm';

type Props = {
  id: string;
  name: string;
};

export const RfidCardDelete = ({ id, name }: Props) => {
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const rfidCards = useSelector((state) => state.variables.RFID_CARDS);

  const handleDelete = () => {
    confirm({
      title: (
        <FormattedMessage
          id="wallbox_rfid.delete.confirm.title"
          defaultMessage="Smazat kartu {name}?"
          values={{ name }}
        />
      ),
      titleProps: { variant: 'h3', textAlign: 'center', lineHeight: 2 },
      confirmationText: (
        <FormattedMessage
          id="wallbox_rfid.delete.confirm"
          defaultMessage="Smazat"
        />
      ),
      cancellationText: (
        <FormattedMessage
          id="wallbox_rfid.delete.cancel"
          defaultMessage="Zrušit"
        />
      ),
      ...confirmYesNo,
    })
      .then(() => {
        const { [id]: _, ...rest } = rfidCards ?? {};
        dispatch(variablesChange({ RFID_CARDS: rest }));
      })
      .catch(() => {
        // noop
      });
  };

  return (
    <IconButton size="small" onClick={handleDelete}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};
